import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { RouterLink, ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.sass']
})
export class CategoryComponent implements OnInit, OnDestroy {
  @Input() categoryName: string
  @Input() category: string = "Badeplatz"
  @Input() description: string = ""

  private sub: Subscription = new Subscription();

  constructor(private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.sub.add(this.route.params.subscribe(params => {
      if (params['category']) {
        if (params['category'] === "badeplaetze") {
          this.categoryName = "Badeplätze";
          this.category = "badeplatz";
          this.description = "Hier findest du alle Badeplätze rund um den Attersee. In unserer Auflistung sind sowohl große öffentliche Bäder, als auch kleinere Seezugänge zu finden. Zu den Badeplätzen gibt es jeweils Fotos, Beschreibungen und einen Standort.\n\nAlle Badeplätze gibt es auch in der Seeguide App.\nViel Spaß beim Stöbern!";
        }
        else if (params['category'] === "restaurants") {
          this.categoryName = "Restaurants";
          this.category = "restaurant";
          this.description = "Hier findest du eine Auswahl der beliebtesten und besten Restaurants rund um den Attersee. Nicht alle Restaurants sind Geheimtipps, also solltest du sicherheitshalber immer vorher Reservieren.\n\nGerne kannst du auch unsere Seeguide App herunterladen und in der App das Restaurant nach deinem Besuch bewerten oder ein Foto von deinem Essen hochladen. Außerdem kannst du in der App alle Restaurants auf einer tollen Übersichtsseite anzeigen lassen.\n\nWir wünschen guten Appetit.";
        }
        else if (params['category'] === "ausfluege") {
          this.categoryName = "Ausflüge";
          this.category = "wanderung";
          this.description = "Hier findest du eine Auswahl von tollen Ausflüge rund um den Attersee. Wir ergänzen die Ausflüge ständig und so wirst du hier nicht nur Wanderungen und tolle Berge finden, sondern auch nette Ausflüge für die ganze Familie.\n\nGerne kannst du die Ausflüge auch in unserer Seeguide App bewerten.";
        }
        else {
          this.router.navigate(["/"]);
        }
      }
      else {
        this.router.navigate(["/"]);
      }
    }));
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}